import { useTakenActions } from "@/organisms/Drawers/components/TriageDrawer/components/TakenActions"
import { TakenActionsCell } from "./TakenActionsCell"

// Holds the hook itself: antd calls a column's render as a plain function.
export const IssueTakenActionsCell = ({ issueId }: { issueId?: string }) => {
  const { actions } = useTakenActions(issueId)

  return <TakenActionsCell actions={actions} />
}

export const renderIssueTakenActions = (_: string, record: { id: string }) => (
  <IssueTakenActionsCell issueId={record.id} />
)
